import { Button } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import ModalPage from './components/modal-page.js';
import { preloadTemplates } from './utils/preload';
import { loadFavorites } from './utils/favorites-service';

const VayuDesignLibraryButton = () => {
    const [open, setOpen] = useState(false);
    preloadTemplates();
    
    loadFavorites({
        setTemplates: () => {}, 
        setLoading: () => {},
        setError: () => {},
    });
        
    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                className="vayu-design-library-btn"
                variant="primary"
                label={__('Vayu Library', 'vayu-blocks')}
            >
                <span className="dashicon dashicons dashicons-vayu-blocks-icon"></span>
                {__('Vayu Library', 'vayu-blocks')}
            </Button>

            {open && <ModalPage onClose={() => setOpen(false)} />}
        </>
    );
};

export default VayuDesignLibraryButton;